<template>
  <div>
    <v-container class="global-margin">
      <v-breadcrumbs :items="breadcrumbs" class="breadcrumbs pl-0" large></v-breadcrumbs>
      <v-row align="center" justify="center">
        <v-col cols="12" md="8">
          <h2 class="display-2 w-100">Google G Suite for Education</h2>
        </v-col>
        <v-col cols="12" md="8" class="text-center">
            <img width="50%" :src="require('@/assets/img/GSuite.png')">
        </v-col>
        <v-col cols="12" md="8">
          <p>Google G Suite for Education je usluga koja omogućuje učiteljima, nastavnicima i učenicima besplatan pristup Google alatima s korisničkim računom na @skole.sum.ba domeni. G Suite omogućuje korisnicima kreiranje sadržaja, zajednički rad korištenjem alata i usluga u javnom Google-ovom oblaku s bilo kojeg mjesta i računala spojenog na Internet.</p>
          <p>Nakon aktivacije računa moguć je direktan pristup do osnovnog paketa G Suite usluga koji uključuje:</p>
          <ul>
              <li><a href="https://drive.google.com/drive/u/0/" target="_blank" class="link">Drive</a> – za pohranu svih datoteka i pristup datotekama s bilo kojeg uređaja</li>
              <li><a href="https://calendar.google.com/calendar/r" target="_blank" class="link">Calendar</a> – za izradu rasporeda i označavanje važnih datuma</li>
              <li><a href="https://docs.google.com/document/u/0/" target="_blank" class="link">Docs</a>, <a href="https://docs.google.com/spreadsheets/u/0/?usp=direct_url" target="_blank" class="link">Sheets</a>, <a href="https://docs.google.com/presentation/u/0/?usp=direct_url" target="_blank" class="link">Slides</a> – za izradu i dijeljenje dokumenata, proračunskih tablica i prezentacija</li>
              <li><a href="https://docs.google.com/forms/u/0/?usp=direct_url" target="_blank" class="link">Forms</a> – za izradu različitih obrazaca, anketa, upitnika </li>
              <li><a href="https://meet.google.com/_meet" target="_blank" class="link">Hangouts Meet</a> – za slanje poruka, videopozive i govorne pozive</li>
              <li><a href="https://groups.google.com/a/sum.ba/forum/#!homeredir" target="_blank" class="link">Groups</a> – za izradu online grupa za svoj tim, razred ili drugu skupinu kako biste razmjenjivali e-poruke, surađivali na projektima ili organizirali sastanke</li>
              <li><a href="https://jamboard.google.com/" target="_blank" class="link">Jamboard</a> – prezentacijska ploča</li>
              <li><a href="https://classroom.google.com/u/0/" target="_blank" class="link">Google Classroom</a> – za organizaciju nastave, raspodjelu zadataka i komunikaciju između nastavnika i učenika </li>
          </ul>
        </v-col>
        <v-col cols="12" md="8" v-for="(item, i) in upute" :key="i">
          <v-card flat :href="item.link">
            <v-row>
              <v-col cols="10">
                <v-card-title style="color: #084776">{{item.title}}</v-card-title>
                <v-card-subtitle>{{item.text}}</v-card-subtitle>
              </v-col>
              <v-col cols="2">
                <v-card-text>
                  <v-icon class="mt-3" color="#084776">fas fa-chevron-right</v-icon>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "GSuite",
  data() {
    return {
      breadcrumbs: [
        {
          text: 'Naslovnica',
          disabled: false,
          to: '/'
        },
        {
          text: 'G Suite',
          disabled: true,
        },
      ],
      upute: [
        {
          title: "Pristup usluzi",
          text: "Kliknite ovdje za pristup usluzi",
          link: "https://myaccount.google.com/"
        },
        {
          title: "Upute za korisnike Google Classroom",
          text: "Kliknite ovdje za preuzimanje uputa",
          link:
            "https://skole.sum.ba/admin/dokumenti/Upute_snimanje_video_lekcija.pdf"
        },
        {
          title: "Upute za korisnike Google Hangouts",
          text: "Kliknite ovdje za preuzimanje uputa",
          link:
            "https://skole.sum.ba/admin/dokumenti/hangouts-meet.pdf"
        },
        {
          title: "Google Meet - pridruživanje sastanku i dijeljenje prezentacije",
          text: "Kliknite ovdje za pregled uputa",
          link:
            "https://www.youtube.com/watch?v=pzDh7sHwWQ0"
        },
        {
          title: "Prebacivanje snimke na Google disk",
          text: "Kliknite ovdje za pregled uputa",
          link:
            "https://www.youtube.com/watch?v=FjnWYFI4dw8"
        },
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.gsuite {
  margin-top: 150px;
}
@media (max-width: 768px) {
  .gsuite {
    margin-top: 120px !important;
  }
}
.link {
    color: #084776;
    text-decoration: none;
}
.v-card__text, .v-card__title {
  word-break: normal;
}
</style>
